import {
  ImportActionTitleStyle,
  ImportButtonStyle,
  ImportIconStyle,
} from "./ExportButton.style";

import { useTranslation } from "react-i18next";
import { ImportButtonPropsInterface } from "./ExportButton.types";
import { FaFileExport } from "react-icons/fa";

function ImportButton({ onAddClick, title, className }: ImportButtonPropsInterface) {
  // translation hooks
  const { t } = useTranslation();
  return (
    <ImportButtonStyle onClick={onAddClick} className={className}>
      <ImportIconStyle />
   
      <ImportActionTitleStyle>{t(title)}</ImportActionTitleStyle>
    </ImportButtonStyle>
  );
}
export default ImportButton;
